<template>
  <v-navigation-drawer
    class="d-flex flex-column"
    v-model="ui.drawer"
    :rail="ui.rail"
    expand-on-hover
    app
    color="grey-lighten-10"
    width="240"
    rail-width="56"
  >
    <!-- LOGO & HEADER -->
    <v-list-item class="sidebar-header" nav>
      <template #prepend>
        <v-img
          v-if="ui.rail"
          :src="logo"
          contain
          width="32"
          height="32"
          @click="$router.push({ name: 'Overview' })"
        />
        <v-img
          v-else
          :src="logo"
          contain
          height="58"
          width="200"
          @click="$router.push({ name: 'Overview' })"
        />
      </template>
    </v-list-item>
    <v-divider />

    <!-- NAV LINKS -->
    <v-list class="flex-1 overflow-y-auto" nav density="comfortable" v-model:opened="openedGroups">
      <template v-for="item in navLinks" :key="item.title">
        <v-divider v-if="item.divider" class="my-2" />
        <v-list-group v-else-if="item.children" :value="item.title" no-action append-icon="">
          <template #activator="{ props }">
            <v-list-item v-bind="props" nav density="comfortable" router link exact>
              <template #prepend>
                <v-icon color="primary">{{ item.icon }}</v-icon>
              </template>
              <v-list-item-title v-if="!ui.rail">{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            v-for="child in item.children"
            :key="child.title"
            :to="child.href ? undefined : child.to"
            :href="child.href"
            :target="child.external ? '_blank' : undefined"
            router
            link
            exact
            class="pl-8"
          >
            <template #prepend>
              <v-icon small color="secondary">{{ child.icon }}</v-icon>
            </template>
            <v-list-item-title v-if="!ui.rail">{{ child.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :to="item.to" router link exact>
          <template #prepend>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </template>
          <v-list-item-title v-if="!ui.rail">{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>

    <v-divider />
    <v-list nav density="comfortable">
      <v-list-item @click="onLogout">
        <template #prepend>
          <v-icon color="primary">mdi-logout</v-icon>
        </template>
        <v-list-item-title v-if="!ui.rail">Logout</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useUIStore } from "@/stores/ui";
import { useAuthStore } from "@/stores/auth";
import logo from "@/assets/images/WaywyserLogo.png";

const ui = useUIStore();
const auth = useAuthStore();
const route = useRoute();

// Navigation links
const navLinks = [
  { title: "Sites", to: "/", icon: "mdi-view-dashboard-outline" },

  { title: "Users", icon: "mdi-account-group", to: "/users", icon: "" },

  { title: "Tour Progress", to: "/tour-progress", icon: "mdi-chart-timeline-variant" },

  { divider: true },
  //{ title: "Settings", to: "/settings", icon: "mdi-cog" },
  { title: "Customer Settings", to: "/customer-settings", icon: "mdi-account-cog" },
];

const openedGroups = ref([]);
watch(
  () => route.path,
  (path) => {
    const parents = navLinks
      .filter((i) => i.children && i.children.some((c) => c.to === path))
      .map((i) => i.title);
    openedGroups.value = [...new Set([...openedGroups.value, ...parents])];
  },
  { immediate: true },
);

const onLogout = () => {
  auth.logout();
};
</script>

<style scoped>
.sidebar-header {
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.07em;
  padding-top: 12px;
  padding-bottom: 6px;
}
.pl-8 {
  padding-left: 12px !important;
}
.profile-activator {
  cursor: pointer;
  padding: 12px 0;
}
.profile-menu {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.sidebar-profile {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #fafbfc;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.v-list-group__items .v-list-item {
  padding-inline-start: 15px !important;
}

.sidebar-profile {
  margin-left: 10px;
}

.v-field__input {
  opacity: 1;
  min-width: 150px !important;
}
</style>
